import { requestImage } from "../../apis";


export const apiUploadImage = ({params}) => 
  requestImage("post", `/api/image/upload`, params, true, false);